// 账户信息
import {post} from './http'
const baseUrl = '/api/admin/account'

// 查询发布方信息 /api/admin/account/findAllCustomerInfo
export const getAccountInfo = v => post(`${baseUrl}/findAllCustomerInfo`, v.data, v.success, v.error)
// 查询账户是否审核
export const queryAudit = v => post(`${baseUrl}/status`, v.data, v.success, v.error)
// 修改账户信息 /api/admin/account/updateCustomerInfo
export const updateCustomerInfo = v => post(`${baseUrl}/updateCustomerInfo`, v.data, v.success, v.error)
// 认证信息查询 /api/admin/account/getVerifyInfo
export const authMsgQuery = v => post(`${baseUrl}/getVerifyInfo`, v.data, v.success, v.error)
// 企业认证 /api/admin/account/saveHostCompanyVerify
export const companyAuthMsg = v => post(`${baseUrl}/saveHostCompanyVerify`, v.data, v.success, v.error)
// 个人实名认证 /api/admin/account/saveHostPersonVerify
export const personalAuthMsg = v => post(`${baseUrl}/saveHostPersonVerify`, v.data, v.success, v.error)
// 公众号详情
export const findMpaccountInfo = v => post(`${baseUrl}/findMpaccountInfo`, v.data, v.success, v.error)
// 公众号列表
export const findMpaccountList = v => post(`${baseUrl}/findMpaccountList`, v.data, v.success, v.error)
// 公众号信息模版
export const findMpmessageTemplateInfo = v => post(`${baseUrl}/findMpmessageTemplateInfo`, v.data, v.success, v.error)
// 公众号模版列表
export const findMpmessageTemplateList = v => post(`${baseUrl}/findMpmessageTemplateList`, v.data, v.success, v.error)
// 新增公众号授权
export const getPublicAccount = v => post(`${baseUrl}/getPublicAccount`, v.data, v.success, v.error)
// 设为默认公众号
export const setDefaultMpaccount = v => post(`${baseUrl}/setDefaultMpaccount`, v.data, v.success, v.error)
// 公众号信息模版编辑样式
export const updateMpmessageTemplateColor = v => post(`${baseUrl}/updateMpmessageTemplateColor`, v.data, v.success, v.error)
// 同步第三方模版消息
export const syncTmplMsg = v => post(`${baseUrl}/syncTmplMsg`, v.data, v.success, v.error)
// 获取自定义消息标准信息
export const getMpmessageconfig = v => post(`${baseUrl}/getMpmessageconfig`, v.data, v.success, v.error)
// 公众号消息推送列表
export const findHostmpmessageconfigList = v => post(`${baseUrl}/findHostmpmessageconfigList`, v.data, v.success, v.error)
// 删除消息推送
export const deleteMessageTemplate = v => post(`${baseUrl}/deleteMessageTemplate`, v.data, v.success, v.error)
// 新增推送消息
export const saveAndUpdateHostmpmessageconfig = v => post(`${baseUrl}/saveAndUpdateHostmpmessageconfig`, v.data, v.success, v.error)
// 获取发布方特定消息的配置信息
export const getHostMessageConfig = v => post(`${baseUrl}/getHostMessageConfig`, v.data, v.success, v.error)
// 刷新公众号token
export const refreshaccesstoken = v => post(`${baseUrl}/refreshaccesstoken`, v.data, v.success, v.error)
// 下拉菜单列表
export const findAllMpaccount = v => post(`${baseUrl}/findAllMpaccount`, v.data, v.success, v.error)
// 获取店铺设置信息 /api/admin/account/getShopSetting
export const getShopSetMsg = v => post(`${baseUrl}/getShopSetting`, v.data, v.success, v.error)
// 更新店铺设置 /api/admin/account/updateShopSetting
export const updateShopSet = v => post(`${baseUrl}/updateShopSetting`, v.data, v.success, v.error)
// 获取机构维护设置信息 /api/admin/account/getShopSettingByCapwhale
export const getShopSettingByCapwhale = v => post(`${baseUrl}/getShopSettingByCapwhale`, v.data, v.success, v.error)
// 设置机构封面图 /api/admin/account/uploadShopBgInfo
export const uploadShopBgInfo = v => post(`${baseUrl}/uploadShopBgInfo`, v.data, v.success, v.error)
// 设置机构详情 /api/admin/account/uploadShopDesp
export const uploadShopDesp = v => post(`${baseUrl}/uploadShopDesp`, v.data, v.success, v.error)
// 设置机构logo /api/admin/account/uploadShopLogo
export const uploadShopLogo = v => post(`${baseUrl}/uploadShopLogo`, v.data, v.success, v.error)
// 设置机构简介 /api/admin/account/uploadShopMemo
export const uploadShopMemo = v => post(`${baseUrl}/uploadShopMemo`, v.data, v.success, v.error)
// 设置机构名称 /api/admin/account/uploadShopName
export const uploadShopName = v => post(`${baseUrl}/uploadShopName`, v.data, v.success, v.error)
// 设置公众号信息 /api/admin/account/uploadShopQRInfo
export const uploadShopQRInfo = v => post(`${baseUrl}/uploadShopQRInfo`, v.data, v.success, v.error)
// 设置客服信息 /api/admin/account/uploadShopServiceInfo
export const uploadShopServiceInfo = v => post(`${baseUrl}/uploadShopServiceInfo`, v.data, v.success, v.error)

// 删除白名单信息 /api/admin/account/whitecustomer/deleteWhiteCustomInfo
export const deleteWhiteCustomInfo = v => post(`${baseUrl}/whitecustomer/deleteWhiteCustomInfo`, v.data, v.success, v.error)
// 发布方白名单列表分页查询 /api/admin/account/whitecustomer/findAllCustomer
export const findAllCustomer = v => post(`${baseUrl}/whitecustomer/findAllCustomer`, v.data, v.success, v.error)
// 根据手机号码获取用户信息 /api/admin/account/whitecustomer/getCustomerInfoByMobile
export const getCustomerInfoByMobile = v => post(`${baseUrl}/whitecustomer/getCustomerInfoByMobile`, v.data, v.success, v.error)
// 获取单个白名单信息 /api/admin/account/whitecustomer/getWhiteCustomInfo
export const getWhiteCustomInfo = v => post(`${baseUrl}/whitecustomer/getWhiteCustomInfo`, v.data, v.success, v.error)
// 新建/编辑白名单信息 /api/admin/account/whitecustomer/saveOrUpdateCustomer
export const saveOrUpdateCustomer = v => post(`${baseUrl}/whitecustomer/saveOrUpdateCustomer`, v.data, v.success, v.error)